module.exports = __webpack_public_path__ + "img/DC-Logo-Web-Color.45c91f1.png";